// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__39PMf","signatureBlock":"Footer_signatureBlock__3iiq0","signature":"Footer_signature__2MZz0"};